import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"
import _imports_0 from 'assets/v2/home-cat.png'
import _imports_1 from 'assets/v2/home-dog.png'


import { Platform } from 'quasar';
import useMenu from 'src/composables/menu';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageDrawer',
  props: {
  drawer: {
    type: Boolean,
    required: true,
  },
},
  emits: ['closeDrawer'],
  setup(__props) {

const { headerLinks } = useMenu();

const headerLinksPerPlatform = computed(() => {
  if (Platform.is.capacitor) {
    return headerLinks.value.filter(
      (headerLink) => !headerLink.hideOnCapacitor
    );
  }
  return headerLinks.value;
});




return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_q_drawer, {
    ref: "drawer",
    "model-value": __props.drawer,
    width: _ctx.$q.screen.width,
    overlay: "",
    class: "drawer",
    "no-swipe-backdrop": "",
    "no-swipe-close": "",
    "no-swipe-open": "",
    onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeDrawer')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_scroll_area, { class: "fit relative-position" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_img, {
            src: _imports_0,
            class: "drawer-cat"
          }),
          _createVNode(_component_q_img, {
            src: _imports_1,
            class: "drawer-dog"
          }),
          _createVNode(_component_q_btn, {
            icon: "fas fa-times",
            class: "absolute-top-right close-btn text-white",
            round: "",
            flat: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.drawer.hide()))
          }),
          _createVNode(_component_q_list, {
            class: "absolute-center",
            style: {"left":"150px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerLinksPerPlatform.value, (menuItem, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    class: "q-my-md",
                    clickable: "",
                    onClick: menuItem.action
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { class: "text-h6 text-weight-bold text-uppercase text-red-primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(menuItem.text), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])), [
                    [_directive_ripple]
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "width"]))
}
}

})